module.exports = __webpack_public_path__ + "img/LogoTVF.f37b1655.png";